import { render, staticRenderFns } from "./Sentiments.vue?vue&type=template&id=42a7fb45&scoped=true"
import script from "./Sentiments.vue?vue&type=script&lang=js"
export * from "./Sentiments.vue?vue&type=script&lang=js"
import style0 from "./Sentiments.vue?vue&type=style&index=0&id=42a7fb45&prod&scoped=true&lang=css"
import style1 from "./Sentiments.vue?vue&type=style&index=1&id=42a7fb45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a7fb45",
  null
  
)

export default component.exports